module.exports = __webpack_public_path__ + "static/Westpac-596c3bea05c597a3d5075cd4618a76de.png";